// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"290":"1b0a34ea","560":"fc954767","945":"ebac38f4"}[chunkId] + ".css";
};